import { MembershipRole } from '@/types/api/membership';
import { MembershipRoleBadge } from './membership-role-badge';

export function MembershipRoleBadges({ roles }: { roles: MembershipRole[] }) {
  return (
    <div className="flex -space-x-2">
      {roles.map((role, index) => (
        <MembershipRoleBadge role={role} key={index} />
      ))}
    </div>
  );
}
